import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={19}
      fill="none"
      viewBox="0 0 19 19"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.577 1.507v4h14.53v-4zM.07 1.095C.07.49.56 0 1.166 0h15.352c.605 0 1.095.49 1.095 1.095v4.823c0 .605-.49 1.095-1.095 1.095H1.166C.56 7.013.07 6.523.07 5.918z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.79 3.507c0-.417.338-.754.754-.754h.211a.754.754 0 0 1 0 1.507h-.21a.754.754 0 0 1-.754-.753M10.229 3.507c0-.417.337-.754.753-.754h.211a.754.754 0 1 1 0 1.507h-.211a.754.754 0 0 1-.753-.753M4.06 7.023v4h13.433v-4zm-1.508-.412c0-.605.49-1.095 1.095-1.095h14.258c.605 0 1.095.49 1.095 1.095v4.823c0 .605-.49 1.095-1.095 1.095H3.647c-.605 0-1.095-.49-1.095-1.095z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.57 9.023c0-.416.338-.754.754-.754h3.858a.754.754 0 0 1 0 1.507h-3.858a.754.754 0 0 1-.754-.753M1.507 12.62v3.999h14.59v-4zM0 12.208c0-.605.49-1.095 1.095-1.095h15.413c.605 0 1.095.49 1.095 1.095v4.823c0 .605-.49 1.095-1.095 1.095H1.095C.49 18.126 0 17.636 0 17.03z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.414 14.62c0-.417.338-.754.754-.754h.572a.754.754 0 0 1 0 1.507h-.572a.754.754 0 0 1-.754-.754"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
